/**
 * Utility function to remove format suffix from text for display and storage
 * This ensures that LLM format instructions are not shown in the UI or saved in user settings
 */
export const removeFormatSuffix = (text: string): string => {
  if (!text || typeof text !== 'string') return text;
  
  const suffixes = [
    ' [FormatHint] Please display the results in a table format.',
    ' [FormatHint] Please display the results in a list format.',
    // Legacy format suffixes for backward compatibility
    ' Display this output in the Table format.',
    ' Display this output in the List format.'
  ];
  
  for (const suffix of suffixes) {
    if (text.endsWith(suffix)) {
      return text.slice(0, -suffix.length);
    }
  }
  
  return text;
};
